import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { toast, confirm } from '../../store/alerts.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { useWoody } from '../../woody/woody.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useResetLocalConnections, useRouter } from '@fabric-app/compat';
import { appRoutes } from '../../app/routing/routes.config.js';
import { integrationsQueryPredicates } from '../queries/integrationsQueryPredicates.js';
import { rootQueryPredicates } from '../../resource-roots/queries/rootQueryPredicates.js';
import { AnalyticsEvents } from '../../analytics/analytics.types.js';

const useMutationIntegrationDelete = () => {
  const { client } = useWoody();
  const { data: user } = useQueryUserInfo();
  const isLoggedIn = !!user;
  const { track } = useAnalytics();
  const queryClient = useQueryClient();
  const reset = useResetLocalConnections();
  const router = useRouter();
  return useMutation({
    mutationFn: async (variables) => {
      if (!isLoggedIn) {
        return;
      }
      const { integration } = variables;
      const confirmed = integration.viewConfig.isSingleMirror ? await confirm({
        title: `Disconnect ${integration.displayName}?`,
        content: "All data associated to it will be permanently removed from your Fabric.",
        confirmLabel: "Yes, disconnect",
        cancelLabel: "Cancel",
        confirmButtonProps: {
          variant: "danger"
        }
      }) : await confirm({
        title: `Disconnect ${integration.displayName}?`,
        content: `All connections associated to it will also be permanently removed, along with their data.`,
        cancelLabel: "Cancel",
        confirmLabel: "Yes, disconnect",
        confirmButtonProps: {
          variant: "danger"
        }
      });
      if (confirmed === false) {
        return false;
      }
      await router.replace(appRoutes.integrations.list);
      await client.v2({
        endpoint: "/v2/integrations/{integrationId}",
        params: {
          integrationId: variables.integration.id
        }
      }, {
        method: "delete"
      });
      return true;
    },
    onSuccess: (result, variables) => {
      if (result) {
        queryClient.invalidateQueries({
          predicate: (q) => integrationsQueryPredicates.integrationByExternalIdAll(q) || rootQueryPredicates.resourceRootAll(q) || integrationsQueryPredicates.integrationsList(q)
        });
        if (variables.integration.viewConfig.isDeviceSync) {
          reset();
        }
        track(AnalyticsEvents.DeletedIntegration, {
          integrationId: variables.integration.id
        });
        toast({
          content: "Connection has been removed",
          id: "remove-connection"
        });
      }
    }
  });
};

export { useMutationIntegrationDelete };
//# sourceMappingURL=useMutationIntegrationDelete.js.map
